// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import React from "react";
import packageJson from "../../package.json";

const Footer = (props) => {
    const date = new Date();
    return (
        <footer {...props}>
            {/* eCloudvalley Digital Technology Co., Ltd. All rights reserved. */}
            <b>
                Copyright &copy; {date.getFullYear()},
                <a  href="https://www.ecloudvalley.com/en"
                    rel="noopener noreferrer" target="_blank">
                    eCloudvalley Digital Technology Co.</a>, Ltd. All rights reserved.
                <small className="version ml-1.5">Version v{packageJson.version}</small>
            </b>
        </footer>
    );
};

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default Footer;
